import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Inject } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { RegistationUtilitiesService } from '../../services/registation-utilities.service';
import { AccountService } from 'src/app/services/accountService/account.service';
import { environment } from 'src/environments/environment';
import { DataLayerService } from 'src/app/services/dataLayer/datalayer.service';
import { SignUpContentServiceService } from '../../services/sign-up-content-service.service';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { verifyEmailPayload } from '../../models/CheckOtpModel';
import { OtpRequestPayload } from 'src/app/models/interface/Registration/registration';
import { CamService } from 'src/app/services/camService/cam.service';
import { AddPassportDetailsComponent } from 'src/app/modules/cam/components/add-passport-details/add-passport-details.component';
import { CommonService } from 'src/app/shared/common/common.service';
import { EmailVerifyMapper } from 'src/app/shared/mapper/email-verify.mapper';
import { ThankyouService } from 'src/app/shared/common/thankyou.service';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField } from '@angular/material/form-field';
import { NgClass, NgIf, NgStyle } from '@angular/common';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { DependentDatalayerService } from 'src/app/services/dataLayer/CAM/dependent.service';
import { jwtDecode } from 'jwt-decode';
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

@Component({
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss'],
  imports: [ReactiveFormsModule, MatIconButton, MatIcon, MatFormField, NgClass, MatInput, NgIf, NgStyle, MatButton, MatProgressSpinner]
})
export class EmailVerificationComponent implements OnInit, OnDestroy, AfterViewInit {
  timer: number = environment.ResendTimer;
  attemptsLeft: number = 3; // Start with 3 attempts
  invalidPassAttemptsLeft: number = 5;
  private maxAttempts: number = 1; // Maximum attempts allowed
  countdown: string = '01:00'; // Initial time is 1 minute
  private timerInterval: any; // Holds the interval reference
  showTimer: boolean = true;
  otpController = new FormControl('', [Validators.required]);
  matcher = new MyErrorStateMatcher();
  email: string = '';
  mobile: string = '';
  countryCode: string = '';
  verifyMode: string = '';
  Message: string = '';
  verifyButtonEnabled: boolean = false;
  otpForm: FormGroup;
  reattemptOTP: number = 0; //GTM use
  hideErrorMsg: boolean = false;
  showErrorMsg: any;
  content: any;
  private destroy$ = new Subject<void>();
  otpChecksum: any;
  isVerifying: boolean = false;
  actionType: any;
  creatorId: any;
  method: any;
  authType: string = '';
  actionDocType: any;
  selectedProfileItem: any;
  actionTypeRegis: any;
  suportUrl: string = "https://www.saudia.com/en/Support/HelpAndSupport";
  travelerPersonalinfoType:string = '';

  constructor(
    public dialogRef: MatDialogRef<EmailVerificationComponent>,
    private service: RegistationUtilitiesService,
    private accountService: AccountService,
    private _DataLayerService: DataLayerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private contentService: SignUpContentServiceService,
    private readonly dictionaryContentService: DisctionaryContent,
    private Utills: RegistationUtilitiesService,
    private _CamService: CamService,
    private _MatDialog: MatDialog,
    public _CommonService: CommonService,
    private readonly _EmailVerifyMapper: EmailVerifyMapper,
    private readonly ThankyouService: ThankyouService,
    private readonly travelerManagement: TravelerManagement,
    private readonly _ToastrApiService: ToastrApiService,
    private readonly _CamApiService: CamService,
    private _DependentDatalayer: DependentDatalayerService
  ) {
    console.log('data---> ffdgd', data);
    this.authType = data?.authType;
    this.method = data?.method;
    this.creatorId = this.data?.creatorId;
    this.actionDocType = data?.actionType;
    this.verifyMode = data?.verifyMode;
    this.travelerPersonalinfoType = data?.travelerPersonalinfo ?? data?.data?.travelerPersonalinfo;
    this.otpForm = new FormGroup({
      digit1: new FormControl('', [
        Validators.required,
        Validators.pattern(/^\d$/),
      ]),
      digit2: new FormControl('', [
        Validators.required,
        Validators.pattern(/^\d$/),
      ]),
      digit3: new FormControl('', [
        Validators.required,
        Validators.pattern(/^\d$/),
      ]),
      digit4: new FormControl('', [
        Validators.required,
        Validators.pattern(/^\d$/),
      ]),
      digit5: new FormControl('', [
        Validators.required,
        Validators.pattern(/^\d$/),
      ]),
      digit6: new FormControl('', [
        Validators.required,
        Validators.pattern(/^\d$/),
      ]),
    });

    this.otpController = new FormControl('', [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(6),
      Validators.pattern(/^\d+$/),
    ]);
  }


  ngOnInit() {
    combineLatest({
      content: this.contentService.content$,
      dictionary: this.dictionaryContentService.content$,
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.content = {
          ...res.content,
          dictionary: res.dictionary,
        };
      });
    this.countryCode = this.data.isdCode;
    this.email = this.maskEmailOrPhone(
      this.data.Email,
      this.data.PhoneNumber,
      this.data.isdCode,
    );
    this.method = this.data.method;
    this.mobile = this.data.PhoneNumber;
    this.verifyMode = this.data.verifyMode;

    if (this.verifyMode === 'sms') {
      this.Message = 'A verification code has been sent to your Phone: ';
      this.email = this.maskMobileWithCountryCode(
        this.data.PhoneNumber,
        this.data.isdCode,
      );
    } else {
      this.Message = 'A verification code has been sent to your email: ';
      this.email = this.maskEmail(this.data.Email);
    }
    this.startCountdown();
    console.log(this.authType, 'this.authType')
    if (this.authType == 'Onboard') {
      // this._DataLayerService.otpVerificationOnboarding('NA', 3, 'Popup_pageview');
      this._DataLayerService.onboarding_authentication_click(this.verifyMode, 'Popup_pageview', this.attemptsLeft, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
    }
    this.gtmCall();

    console.log(this.content)
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const firstInput = document.getElementById('digit1') as HTMLInputElement;
      if (firstInput) {
        firstInput.focus();
      }
    }, 300);
  }

  gtmCall() {
    switch (this.data.actionType || this.data?.data.actionType) {
      case 'REGISTER':
        this._DataLayerService.registration_authentication_click(this.data.verifyMode, this.attemptsLeft); //GTM use
        break;
      case 'ThisIsMe':
        if (this.authType !== 'Onboard') {
          this.travelerManagement.authentication_popup('PopUp_pageview', this.verifyMode);
        }
        if (this.method == 'dependentMatch') {
          this._DependentDatalayer.linkAccountAuthenticationCTA('dependent_authentication', this.verifyMode, this.attemptsLeft);
        }
        break;
      case 'DocumentAdd':
        if (this.authType !== 'Onboard') {
          this.travelerManagement.authentication_popup('PopUp_pageview', this.verifyMode);
        }
        if (this.method == 'dependentMatch') {
          this._DependentDatalayer.linkAccountAuthenticationCTA('dependent_authentication', this.verifyMode, this.attemptsLeft);
        }

        break;
      case 'DocumentUpdate':
        if (this.authType !== 'Onboard') {
          this.travelerManagement.authentication_popup('PopUp_pageview', 'email');
        }
        if (this.method == 'dependentMatch') {
          this._DependentDatalayer.linkAccountAuthenticationCTA('dependent_authentication', this.verifyMode, this.attemptsLeft);
        }
        break;
      default:
        console.error('Unknown action type');
    }
  }
  private getUserType(): string {
    return this.creatorId === 0 ? 'Admin' : 'Employee';
  }

  private maskMobileWithCountryCode(
    mobile: string,
    countryCode: string,
  ): string {
    if (!mobile || mobile.length < 3) return mobile;
    const maskedMobile = `*********${mobile.slice(-3)}`;
    return `${countryCode ? countryCode + ' ' : ''}${maskedMobile}`;
  }
  private maskEmail(email: string): string {
    if (!email || !email.includes('@')) return email;

    const [localPart, domain] = email.split('@');

    const visibleLength = Math.min(3, localPart.length); // Show up to 3 characters
    const maskedLocalPart =
      localPart.length > visibleLength
        ? `${localPart.slice(0, visibleLength)}${'.'.repeat(
          localPart.length - visibleLength,
        )}`
        : localPart;

    return `${maskedLocalPart}@${domain}`;
  }
  private maskEmailOrPhone(
    email: string,
    phone: string,
    countryCode: string,
  ): string {
    return phone
      ? this.maskMobileWithCountryCode(phone, countryCode)
      : this.maskEmail(email);
  }
  moveFocus(event: any, index: number) {
    const input = event.target;
    const value = input.value;

    if (
      value.length === 1 &&
      index < 6 &&
      event.inputType !== 'deleteContentBackward'
    ) {
      // Move to the next field and select its value
      const nextInput = document.getElementById(
        `digit${index + 1}`,
      ) as HTMLInputElement;
      if (nextInput) {
        nextInput.focus();
        nextInput.select();
      }
    } else if (value === '' && event.inputType === 'deleteContentBackward') {
      // Move to the previous field on backspace if empty
      const prevInput = document.getElementById(
        `digit${index - 1}`,
      ) as HTMLInputElement;
      if (prevInput) {
        prevInput.focus();
        prevInput.select();
      }
    }
  }
  allowOnlyDigits(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  onVerify(): void {
    this.isVerifying = true;
    // GTM Verify Click
    if (this.travelerPersonalinfoType == 'isTravelerPersonalinfo') {
      this.travelerManagement.authentication_popup('Verify', this.data.verifyMode == 'email' ? 'email' : 'mobile');
    }
    if (this.authType == 'Onboard') {
      this._DataLayerService.onboarding_authentication_click(this.verifyMode, 'Verify', this.attemptsLeft, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
    }
    if (this.method == 'dependentMatch') {
      this._DependentDatalayer.linkAccountAuthenticationCTA('Verify', this.verifyMode, this.attemptsLeft);
    }
    switch (this.data.actionType || this.data?.data.actionType) {
      case 'REGISTER':
        this.registerCorporate();
        break;

      case 'LINK_ACCOUNT':
        this.createContact();
        break;

      case 'DocumentUpdate':
        this.verifyOTPdocumentUpdate();
        break;

      case 'DocumentAdd':
        this.documentAdd();
        break;

      case 'ThisIsMe':
        if (this.method == 'dependentMatch') {
          this.thisIsMeDependentOnboard();
        } else if (this.method == 'documentInfoAdd') {
          this.thisIsMeDocumentInfoADD()
        } else if (this.method == 'documentInfoMatch') {
          this.thisIsMeDocumentInfoChange()
        } else if (this.method == 'personalInfoMobMatch') {
          this.personalInfoAlfursanMatch()
        }
        else {
          this.thisISMeContactCreate();
        }
        break;

      case 'notMe':
        console.log(this.method)
        if (this.method == 'dependentMatch') {
          this.dependentOnboard();
        } else if (this.method == 'personalInfoMobMatch') {
          this.personalInfoMobNotMe()
        }
        else if (this.method == 'beforeLoginCIAMmobileMatch') {
          this.callSecondApi();
          return;
        }
        else {
          this.notMecreateContact();
        }
        break;

      case 'phoneEnrollment':
        this.savePhoneEnrollment();
        break;

      case 'UserDeactivate':
        this.verifyOTPUserDeactivate();
        break;

      case 'PI_MObile_Update':
        this.verifyOTP();
        break;

      default:
        this.isVerifying = false;
        console.error('Unknown action type');
    }
    if (this.actionType == 'PI_MObile_Update') {
      //GTM call
      if (this.authType !== 'Onboard') {
        this.travelerManagement.authentication_popup('Verify', this.verifyMode);
      }
      if (this.method == 'dependentMatch') {
        this._DependentDatalayer.linkAccountAuthenticationCTA('Verify', this.verifyMode, this.attemptsLeft);
      }

    }
  }



  handleInvalidOtp(): void {
    this.invalidPassAttemptsLeft--;
    // Highlight each digit input field
    Object.keys(this.otpForm.controls).forEach((key) => {
      const control = this.otpForm.get(key);
      if (control) {
        control.setErrors({ incorrect: true });
      }
    });

    this.showErrorMsg =
      this.invalidPassAttemptsLeft > 0
        ? `Invalid OTP! You have ${this.invalidPassAttemptsLeft} attempts left.`
        : 'Verification attempts maxed out. Please try again in some time.';
    // if (this.authType !== 'Onboard') {
    //   this.travelerManagement.authentication_success(this.showErrorMsg);
    // }
    // this.travelerManagement.authentication_success(this.showErrorMsg);naz

    if (this.invalidPassAttemptsLeft <= 0) {
      clearInterval(this.timerInterval);
      this.showTimer = false;
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
    this.dialogRef.afterClosed().subscribe(() => { });
    if (this.travelerPersonalinfoType == 'isTravelerPersonalinfo') {
      this.travelerManagement.authentication_popup('Close', this.data.verifyMode == 'email' ? 'email' : 'mobile');
    }
    if (this.authType == 'Onboard') {
      this._DataLayerService.onboarding_authentication_click(this.verifyMode, 'Close', this.attemptsLeft, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
    }

    if (this.actionType == 'PI_MObile_Update' || this.actionType == 'DocumentUpdate') {
      if (this.authType !== 'Onboard') {
        this.travelerManagement.authentication_popup('Close', this.verifyMode);
      }
      if (this.method == 'dependentMatch') {
        this._DependentDatalayer.linkAccountAuthenticationCTA('Close', this.verifyMode, this.attemptsLeft);
      }
    }
    if (this.authType !== 'Onboard') {
      if (this.actionDocType == 'DocumentAdd') {
        this.travelerManagement.authentication_popup('Close', this.verifyMode);
      }
      if (this.method == 'dependentMatch') {
        this._DependentDatalayer.linkAccountAuthenticationCTA('Close', this.verifyMode, this.attemptsLeft);
      }
      if (this.actionDocType == 'REGISTER') {
        this._DataLayerService.registration_authentication_click(
          this.data.verifyMode,
          this.attemptsLeft,
          'close'
        ); //GTM use
      }


    }

    if (this.attemptsLeft == 0) {
      this._DataLayerService.verifyOTP(
        this.data.verifyMode,
        this.reattemptOTP,
        'close',
      ); //GTM use
      // this._DataLayerService.otpVerificationOnboarding(
      //   'NA',
      //   this.attemptsLeft,
      //   'Close',
      // );
      // this._DataLayerService.onboarding_authentication_click('NA',this.verifyMode, this.attemptsLeft, 'Close');
    }
  }
  dependentOnboard() {
    const payload = this.data.data;
    this._CamService
      .updateDependentProfile(payload)
      .then((res) => {
        if (!res) {
          this._ToastrApiService.show(
            'error',
            'No response received from server.'
          );
          return;
        }
        this.dialogRef.close();
        this.dialogRef.afterClosed().subscribe(() => {
          this.travelerManagement.dependent_addition_success('Success');
          this._DependentDatalayer.addedSuccessfully('Email', 'You have been added as a family member.');
          this.ThankyouService.show({
            heading: 'You have been added as a family member.',
            description: this.creatorId == 0 ? '' : 'Your profile is now submitted for approval.',
            buttonText: 'Go To Login',
            isShowButton: false,
            redirectUrl: '',
          });
        })
      })
      .catch((error) => {
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          'Something went wrong while saving the traveler. Please try again later.';

        this._ToastrApiService.show('error', errorMessage);
      });
  }
  thisIsMeDependentOnboard() {
    const payload = this.data.data;
    payload['additionalRefId'] = this.data.contactId;
    this._CamService
      .updateDependentProfile(payload)
      .then((res) => {
        if (!res) {
          this._ToastrApiService.show(
            'error',
            'No response received from server.'
          );
          return;
        }
        this.dialogRef.close();
        this.dialogRef.afterClosed().subscribe(() => {
          this.travelerManagement.dependent_addition_success('Success');
          this._DependentDatalayer.addedSuccessfully('Email', 'You have been added as a family member.');
          this.ThankyouService.show({
            heading: 'You have been added as a family member.',
            description: this.creatorId == 0 ? '' : 'Your profile is now submitted for approval.',
            buttonText: 'Go To Login',
            isShowButton: false,
            redirectUrl: '',
          });
        })
      })
      .catch((error) => {
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          'Something went wrong while saving the traveler. Please try again later.';

        this._ToastrApiService.show('error', errorMessage);
      });
  }
  private startCountdown(): void {
    let time = this.timer; // 1 minute in seconds
    this.timerInterval = setInterval(() => {
      time--;
      const minutes = Math.floor(time / 60);
      const seconds = time % 60;
      this.countdown = `${this.formatTime(minutes)}:${this.formatTime(
        seconds,
      )}`;

      if (time <= 0) {
        clearInterval(this.timerInterval); // Stop the timer when it reaches 0
        this.showTimer = false;
      }
    }, 1000);
  }
  private formatTime(time: number): string {
    return time < 10 ? '0' + time : time.toString(); // Format time as two digits (e.g., 01, 09)
  }

  onResendCodeClick(): void {
    this.hideErrorMsg = true;
    //  GTM Resend
    if (this.travelerPersonalinfoType == 'isTravelerPersonalinfo') {
      this.travelerManagement.authentication_popup('Resend', this.data.verifyMode == 'email' ? 'email' : 'mobile');
    }

    if (this.authType == 'Onboard') {
      //   this._DataLayerService.otpVerificationOnboarding(
      //   this.data.verifyMode == 'email' ? 'email' : 'mobile',
      //   this.attemptsLeft,
      //   'Resend',
      // );
      this._DataLayerService.onboarding_authentication_click(this.data.verifyMode == 'email' ? 'email' : 'mobile', 'Resend', this.attemptsLeft, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
    }


    // this._DataLayerService.onboarding_authentication_click( 
    //   this.data.verifyMode == 'email' ? 'email' : 'mobile', 'Resend', this.attemptsLeft 
    // );

    if (this.attemptsLeft > 0) {
      this.otpController.setErrors(null);
      this.otpForm.reset();

      const action = this.data.actionType || this.data?.data?.actionType;

      if (action === 'phoneEnrollment') {
        const payload = {
          phone_number: `${this.data.isdCode}${this.data.PhoneNumber}`
        };

        this._CamApiService.phoneVerification(payload).subscribe({
          next: (res: any) => {
            if (res?.data?.auth_session) {
              this.data.authSession = res.data.auth_session;
              this.data.phoneId = res.data.id;
            }
            this.startCountdown();
            this.attemptsLeft--;
            this.reattemptOTP++; //GTM use
          },
          error: (err: any) => {
            console.error('Error resending OTP:', err);
          }
        });
        return;
      }

      const token = localStorage.getItem('access_token');
      const sessionID = localStorage.getItem('session_id');

      const payload: OtpRequestPayload = {
        type: this.data.verifyMode == 'email' ? 'email' : 'mobile',
        otpAction: 'mobileOrEmailValidation',
        value:
          this.data.verifyMode == 'email'
            ? this.data.Email
            : this.data.PhoneNumber,
        channel: this.data.verifyMode == 'email' ? 'email' : 'mobile',
        companyId: 'SAA',
        b2BId: null,
        b2BUserId: null,
        eventName: 'REGISTRATION',
      };

      this.Utills.sendOTPV1(token, sessionID, payload).subscribe(
        (res: any) => {
          this.otpChecksum = res?.data?.checksum || null;
          this.startCountdown();
          this.attemptsLeft--;
          this.reattemptOTP++; //GTM use
          if (this.authType !== 'Onboard') {
            if (this.actionDocType == 'DocumentAdd') {
              this.travelerManagement.authentication_popup('Resend', this.verifyMode);
            }
            if (this.method == 'dependentMatch') {
              this._DependentDatalayer.linkAccountAuthenticationCTA('Resend', this.verifyMode, this.attemptsLeft);
            }
            if (this.actionDocType == 'REGISTER') {
              this._DataLayerService.registration_authentication_click(
                this.data.verifyMode,
                this.attemptsLeft,
                'Resend_Code',
              ); //GTM use
            }

          }

          // this._DataLayerService.verifyOTP(
          //   this.data.verifyMode,
          //   this.attemptsLeft,
          //   'resend code',
          // ); //GTM use
          if (this.actionType == 'PI_MObile_Update') {
            if (this.authType !== 'Onboard') {
              this.travelerManagement.authentication_popup('Resend', this.verifyMode);
            }
            if (this.method == 'dependentMatch') {
              this._DependentDatalayer.linkAccountAuthenticationCTA('Resend', this.verifyMode, this.attemptsLeft);
            }

          }
        },
        (error: any) => {
          console.error('Error resending OTP:', error);
          const details = error?.error?.details?.[0];
          if (details?.code === 'DUPLICATE_ENTRY') {
            this._ToastrApiService.show('error', details.title || 'Entry is already present, Please generate token after 30 seconds.');
          } else {
            const msg = error?.error?.message || error?.message || 'Something went wrong';
            this._ToastrApiService.show('error', msg);
          }
        },
      );
    }
  }

  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement; // Cast event.target to HTMLInputElement
    let otpValue = inputElement.value; // Get the OTP value

    // If the OTP length exceeds 6, trim it to the first 6 digits
    if (otpValue.length > 6) {
      otpValue = otpValue.slice(0, 6); // Trim input to 6 characters
      inputElement.value = otpValue; // Update the input field with the trimmed value
    }

    // Check if the OTP is exactly 6 digits long
    if (otpValue.length === 6) {
      // Enable the Verify button if the OTP length is 6
      this.verifyButtonEnabled = true;
    } else {
      // Disable the Verify button if the OTP length is not 6
      this.verifyButtonEnabled = false;
    }
  }

  registerCorporate() {
    this._DataLayerService.registration_authentication_click(this.data.verifyMode, this.attemptsLeft, 'Verify',); //GTM use
    const formpayload = this.data;

    this._EmailVerifyMapper.registrationPayload(formpayload);
    const payload: verifyEmailPayload = {
      CompanyId: formpayload.CompanyId,
      Title: formpayload.Title,
      FirstName: formpayload.FirstName,
      LastName: formpayload.LastName,
      Email: formpayload.Email,
      CountryCode: formpayload.CountryCode,
      Country: formpayload.Country,
      CompanyName: formpayload.CompanyName,
      NatureOfBusiness: formpayload.NatureOfBusiness,
      City: formpayload.City,
      HeadOfficeAddress: formpayload.HeadOfficeAddress,
      districtName: formpayload.districtName,
      buildingNumber: formpayload.buildingNumber,
      CompanyUrl: formpayload.CompanyUrl,
      Language: formpayload.Language,
      verifyMode: formpayload.verifyMode,
      NoOFEmployees: formpayload.NoOFEmployees,
      Region: formpayload.Region,
      registrationId: formpayload.registrationId,
      NationalID: formpayload.NationalID,
      Nationality: formpayload.Nationality,
      countryOfResidence: formpayload.countryOfResidence,
      DOB: formpayload.DOB,
      EmpCode: formpayload.EmpCode,
      PhoneNumber: formpayload.PhoneNumber,
      isdCode: formpayload.isdCode,
      Telephone: formpayload.Telephone,
      AnnualBudget: formpayload.AnnualBudget,
      PostalCode: formpayload.PostalCode,
      Gender: formpayload.Gender,
      hasCompanyDomain: formpayload.hasCompanyDomain,
      taxIdentifcationNo: formpayload.taxIdentifcationNo,
      documentType: formpayload.documentType,
      actionType: formpayload.actionType,
      JobTitle: formpayload.JobTitle,
      docExpiry: formpayload.docExpiry,
      otp: Object.values(this.otpForm.value).join(''),
      checksum: this.otpChecksum || formpayload.otpChecksum,
      type: formpayload.verifyMode == 'email' ? 'email' : 'mobile',
      value:
        formpayload.verifyMode == 'email'
          ? formpayload.Email
          : formpayload.PhoneNumber,
      otpAction: 'mobileOrEmailValidation',
      Channel: formpayload.verifyMode == 'email' ? 'email' : 'mobile',
      companyId: formpayload.CompanyId,
      B2BId: null,
      B2BUserId: null,
      eventName: formpayload.actionType,
      companyDomain: formpayload.domainName,
    };
    //OTP Email verification 
    //this.otpEmailVerification(formpayload);

    this.service.registerCorporate(payload).subscribe({
      next: (response: any) => {
        if (
          response.status === 201 ||
          response?.status == 'Success' ||
          (response.status >= 200 && response.status < 300)
        ) {
          this._DataLayerService.verifyOTP(payload?.type, this.attemptsLeft, 'Success',);

          //Corporte Registration Welcome sucessfull message

          //this.corporateRegistrationWelcome(formpayload);

          this.isVerifying = false;
          this.dialogRef.close();
          this.dialogRef.afterClosed().subscribe(() => {
            this.ThankyouService.show({
              heading: 'Thank you for registering with Saudia Business',
              description:
                'We will verify your company details within 2 business days. Once approved, you will receive a confirmation email.',
              buttonText: 'Go To Homepage',
              isShowButton: true,
              redirectUrl: '/',
            });
            this._DataLayerService.successfull_registration(payload);
          });
        }
        else if (response?.status === 'Failure') {
          this.isVerifying = false;
          let msg = response?.message || 'Verification failed';

          if (msg === 'Incorrect OTP') {
            this.handleInvalidOtp();
            let showErrorMsg = this.invalidPassAttemptsLeft > 0 ? `Invalid OTP! You have ${this.invalidPassAttemptsLeft} attempts left.` : 'Verification attempts maxed out. Please try again in some time.';
            // this._ToastrApiService.show('error', showErrorMsg);
            this._DataLayerService.verifyOTPFailure(payload?.type, this.attemptsLeft, showErrorMsg, 'Failure');
          } else {
            this._ToastrApiService.show('error', msg);
            this._DataLayerService.verifyOTPFailure(payload?.type, this.attemptsLeft, msg, 'Failure');
            this.dialogRef.close();
          }
        } else {
          this.isVerifying = false;
          let msg = 'Unexpected response from server.';
          this._ToastrApiService.show('error', msg);
          this._DataLayerService.verifyOTPFailure(payload?.type, this.attemptsLeft, msg, 'Failure');
          this.dialogRef.close();
        }
      },
      error: (error: any) => {
        this.isVerifying = false;
        console.error('Registration error:', error);
        const apiErrorMessage = error?.error?.message || error?.message;

        if (apiErrorMessage === 'Incorrect OTP') {
          this.handleInvalidOtp();
          let showErrorMsg = this.invalidPassAttemptsLeft > 0 ? `Invalid OTP! You have ${this.invalidPassAttemptsLeft} attempts left.` : 'Verification attempts maxed out. Please try again in some time.';
          // this._ToastrApiService.show('error', showErrorMsg);
          this._DataLayerService.verifyOTPFailure(payload?.type, this.attemptsLeft, showErrorMsg, 'Failure');
        } else {
          let msg = apiErrorMessage || (error?.status === 500 ? 'Server error occurred. Please try again later.' : 'Registration failed. Please try again.');
          try {
            const parsedMsg = JSON.parse(apiErrorMessage);
            msg = parsedMsg?.details?.[0]?.message?.message || parsedMsg?.details?.[0]?.message?.Message || msg;
            if (parsedMsg?.target) {
              msg = `${parsedMsg?.message || msg} - Target: ${parsedMsg?.target}`;
            }
          } catch (e) { }

          this._ToastrApiService.show('error', msg);
          this._DataLayerService.verifyOTPFailure(payload?.type, this.attemptsLeft, msg, 'Failure');
          this.dialogRef.close();
        }
      },
    });
  }

  createContact() {

    // this._DataLayerService.otpVerificationOnboarding(
    //   'email',
    //   this.attemptsLeft,
    //   'Verify',
    // );

    this._DataLayerService.onboarding_authentication_click(this.data.verifyMode === 'email' ? 'email' : 'mobile', 'Verify', this.attemptsLeft);

    const d = this.data.data;
    const token = this.data.token;
    const seesionID = this.data.sessionID;

    const payload = {
      firstName: d.firstname,
      lastName: d.lastname,
      dateOfBirth: this._CommonService.formatDateToYMD(d.dateOfBirth),
      title: d.title,
      gender: d.gender,
      placeOfResidence: d.residence,
      nationality: d.Nationality,
      email: d.email,
      mobile: d.mobileNumber,
      phoneExtension: d.countryCode,
      employeeCode: d.empCode,
      employeeType: this.data.EmpType,
      idNumber: d.identityNumber,
      // idType: this.data.idType,
      idType: this.data.idType === 'iqama' ? 'Iqama' : this.data.idType === 'nationalID' ? 'National ID' : this.data.idType === 'passport' ? 'Passport' : this.data.idType,
      passportNationality: d.Nationality,
      designationId: d.designation,
      departmentId: d.department ?? null,
      branchId: d.branch,
      AlFursanId: d.alfursanID,
      expiryDate: this._CommonService.formatDateToYMD(this.data.expiryDate),
      password: d.password,
      elmVerified: this.data.elmStatus,
      consentTCPP: this.data.ConsentTCPP,
      consentMarketingOffers: this.data.ConsentMarketing,
      consentLinkAccount: false,
      contactId: '',
      // accountId: '4349855f-8ad6-f011-8544-7ced8d4254b4',
      accountId: d.accountID,
      vUserDataKey: this.data?.vUserDataKey,
      flag: 'CREATE',
      companyId: 'SAA',
      otp: Object.values(this.otpForm.value).join(''),
      checksum: this.otpChecksum || this.data.otpChecksum,
      type: 'email',
      value: this.data.Email,
      otpAction: 'mobileOrEmailValidation',
      Channel: 'email',
      B2BId: null,
      B2BUserId: null,
      eventName: this.data.actionType,
      subagentId: d.subagentId,
      saUserId: d.saUserId,
      userGuid: d.userGuid,
    };

    this.service.createNewContact(token, seesionID, null, payload).subscribe({
      next: (res) => {
        console.log(res);
        this.isVerifying = false;
        this.dialogRef.close();
        this._DataLayerService.otpVerificationSuccessOnboarding(
          payload?.type,
          'Thank you for joining Saudia Business',
          'Success',
          payload?.employeeType == '0' ? 'Admin' : payload?.employeeType == '1' ? 'Travel Arranger' : 'Employee'
        );
        this.dialogRef.afterClosed().subscribe(() => {
          this.ThankyouService.show({
            heading: 'Profile successfully created!',
            // description: 'We will verify your company details within 2 business days. Once approved, you will receive a confirmation email.',
            buttonText: 'Go To Login',
            isShowButton: true,
            redirectUrl: '/login-landing',
          });
        });
      },

      error: (err) => {
        console.error('API error:', err);
        this.isVerifying = false;
        const apiErrorMessage = err?.error?.message;

        if (apiErrorMessage === 'Incorrect OTP') {
          let showErrorMsg = this.invalidPassAttemptsLeft > 0 ? `Invalid OTP! You have ${this.invalidPassAttemptsLeft} attempts left.` : 'Verification attempts maxed out. Please try again in some time.';
          if (this.authType == 'Onboard') {
            this._DataLayerService.errors_occured(showErrorMsg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
          }
          this.handleInvalidOtp();
        } else {
          let msg = apiErrorMessage || 'Something went wrong';
          try {
            const parsedMsg = JSON.parse(apiErrorMessage);
            msg = parsedMsg?.details?.[0]?.message?.message || parsedMsg?.details?.[0]?.message?.Message || msg;
            if (parsedMsg?.target) {
              msg = `${parsedMsg?.message} - Target: ${parsedMsg.target}`;
            }
          } catch (e) { }

          this._ToastrApiService.show('error', msg);
          if (this.authType == 'Onboard') {
            this._DataLayerService.onboarding_error('Account already exists', msg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
            this._DataLayerService.errors_occured(msg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
            this._DataLayerService.otpVerificationErrorOnboarding(payload?.type, msg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
          }
        }
      },
    });
  }

  thisISMeContactCreate() {

    console.log(this.data);
    const sessionID = localStorage.getItem('session_id');
    const token = localStorage.getItem('access_token');
    const d = this.data.data;
    // const token = this.data.token;
    // const seesionID = this.data.sessionID;

    const payload = {
      firstName: d.firstname,
      lastName: d.lastname,
      dateOfBirth: this._CommonService.formatDateToYMD(d.dateOfBirth),
      title: d.title,
      gender: d.gender,
      placeOfResidence: d.residence,
      nationality: d.Nationality,
      email: d.email,
      mobile: d.mobileNumber,
      phoneExtension: d.countryCode,
      employeeCode: d.empCode,
      employeeType: d.userType,
      idNumber: d.identityNumber,
      // idType: this.data.idType,
      idType: this.data.idType === 'iqama' ? 'Iqama' : this.data.idType === 'nationalID' ? 'National ID' : this.data.idType === 'passport' ? 'Passport' : this.data.idType,
      passportNationality: d.Nationality,
      designationId: d.designation,
      departmentId: d.department ?? null,
      branchId: d.branch,
      AlFursanId: d.alfursanID,
      expiryDate: this._CommonService.formatDateToYMD(d.docExpiary),
      password: d.password,
      // elmVerified: this.data.elmStatus,
      // isELMVerified: this.data?.elmStatus,
      // elmVerificationDate: this.data?.elmVerificationDate,
      elmVerified: this.data?.isELMVerified || this.data?.elmStatus || d?.isELMVerified || d?.elmStatus || false,
      isELMVerified: this.data?.isELMVerified || this.data?.elmStatus || d?.isELMVerified || d?.elmStatus || false,
      elmVerificationDate: (this.data?.isELMVerified || this.data?.elmStatus || d?.isELMVerified || d?.elmStatus) ? (this.data?.elmVerificationDate || d?.elmVerificationDate || new Date().toISOString()) : null,
      consentTCPP: this.data.consentTCPP,
      consentMarketingOffers: this.data.consentMarketingOffers,
      consentLinkAccount: true,
      contactId: this.data.contactId,
      // accountId: '4349855f-8ad6-f011-8544-7ced8d4254b4',
      accountId: d.accountID,
      vUserDataKey: this.data?.vUserDataKey,
      flag: 'CREATE',
      companyId: 'SAA',
      otp: Object.values(this.otpForm.value).join(''),
      checksum: this.otpChecksum || this.data.otpChecksum,
      type: 'email',
      value: this.data.Email,
      otpAction: 'mobileOrEmailValidation',
      Channel: 'email',
      B2BId: null,
      B2BUserId: null,
      eventName: this.data.actionType,
      subagentId: d.subagentId,
      saUserId: d.saUserId,
      userGuid: d.userGuid,
    };
    this.service.createNewContact(token, sessionID, null, payload).subscribe({
      next: (res) => {
        console.log(res);
        this.isVerifying = false;
        this.dialogRef.close();
        this._DataLayerService.otpVerificationSuccessOnboarding(
          payload?.type,
          'Thank you for joining Saudia Business',
          'Success',
          payload?.employeeType == '0' ? 'Admin' : payload?.employeeType == '1' ? 'Travel Arranger' : 'Employee'
        );
        this.dialogRef.afterClosed().subscribe(() => {
          this.ThankyouService.show({
            heading: 'Profile linked successfully!',
            // description: 'We will verify your company details within 2 business days. Once approved, you will receive a confirmation email.',
            buttonText: 'Go To Login',
            isShowButton: true,
            redirectUrl: '/login-landing',
            employeeType: payload?.employeeType,
          });
        });
      },

      error: (err) => {
        console.error('API error:', err);
        this.isVerifying = false;
        const apiErrorMessage = err?.error?.message;

        if (apiErrorMessage === 'Incorrect OTP') {
          let showErrorMsg = this.invalidPassAttemptsLeft > 0 ? `Invalid OTP! You have ${this.invalidPassAttemptsLeft} attempts left.` : 'Verification attempts maxed out. Please try again in some time.';
          if (this.authType == 'Onboard') {
            this._DataLayerService.errors_occured(showErrorMsg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
          }
          if (this.authType == 'Onboard') {
            this._DataLayerService.otpVerificationErrorOnboarding(
              payload?.type,
              showErrorMsg,
              this.data?.data?.userType == '0' ? 'Admin' : 'Employee'
            );
          }
          this.handleInvalidOtp();
        } else {
          let msg = apiErrorMessage || 'Something went wrong';
          try {
            const parsedMsg = JSON.parse(apiErrorMessage);
            msg = parsedMsg?.details?.[0]?.message?.message || parsedMsg?.details?.[0]?.message?.Message || msg;
            if (parsedMsg?.target) {
              msg = `${parsedMsg?.message} - Target: ${parsedMsg.target}`;
            }
          } catch (e) { }
          if (this.authType == 'Onboard') {
            this._ToastrApiService.show('error', msg);
            this._DataLayerService.onboarding_error('Account already exists', msg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
            this._DataLayerService.errors_occured(msg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
            this._DataLayerService.otpVerificationErrorOnboarding(payload?.type, msg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
          }
        }
      },
    });
  }

  verifyOTPdocumentUpdate() {
    const payload = {
      otp: Object.values(this.otpForm.value).join(''),
      checksum: this.data.otpChecksum,
      type: 'email',
      value: this.data.Email,
      otpAction: 'mobileOrEmailValidation',
      channel: 'email',
      companyId: 'SAA',
      eventName: this.data.actionType,
      b2BId: null,
      b2BUserId: null,
    };
    if (this.authType !== 'Onboard') {
      this.travelerManagement.authentication_popup('Confirm', payload.type);
    }
    const localSessionId = localStorage.getItem('session_id');
    this._CamService
      .VerifyOTP(payload)
      .then((res: any) => {
        if (res.data.otpVerified) {
          const resSessionId: any = jwtDecode(res.data?.secureSessionId);
          if (localSessionId != resSessionId?.['sessionId']) {
            return;
          }
          this.isVerifying = false;
          if (this.authType !== 'Onboard') {
            if (this.actionDocType == 'DocumentAdd') {
              this.travelerManagement.authentication_popup('Close', payload.type);
            }
            if (this.method == 'dependentMatch') {
              this._DependentDatalayer.linkAccountAuthenticationCTA('Close', this.verifyMode, this.attemptsLeft);
            }
          }

          this.dialogRef.close();
          if (this.authType !== 'Onboard') {
            if (this.actionDocType == 'DocumentAdd') {
              this.travelerManagement.authentication_success('Verify', 'Success');
            }

            if (this.method == 'dependentMatch') {
              this._DependentDatalayer.linkAccountAuthenticationCTA('Verify', this.verifyMode, this.attemptsLeft);
            }

          }

          this._MatDialog.open(AddPassportDetailsComponent, {
            data: {
              element: this.data.element,
              edit: true,
              personalInfo: this.data.personalInfo,
            },
            width: '600px',
            autoFocus: false,
            panelClass: 'custom-passport-dialog',
          });
        } else {
          if (this.authType == 'Onboard') {
            this._DataLayerService.otpVerificationErrorOnboarding(
              payload?.type,
              res?.message,
              this.data?.data?.userType == '0' ? 'Admin' : 'Employee'
            );
          }

          this.isVerifying = false;
          this.handleInvalidOtp(); // 👈 call on error
        }
      })
      .catch((error: any) => {
        this.isVerifying = false;
        this.handleInvalidOtp();
        if (this.authType == 'Onboard') {
          this._DataLayerService.otpVerificationErrorOnboarding(
            payload?.type,
            error?.message,
            this.data?.data?.userType == '0' ? 'Admin' : 'Employee'
          );
        }
      });
  }

  documentAdd() {
    if (this.authType !== 'Onboard') {
      if (this.actionDocType == 'DocumentAdd') {
        this.travelerManagement.authentication_popup('Verify', this.verifyMode);
      }
      if (this.method == 'dependentMatch') {
        this._DependentDatalayer.linkAccountAuthenticationCTA('Verify', this.verifyMode, this.attemptsLeft);
      }
    }
    const payload = {
      otp: Object.values(this.otpForm.value).join(''),
      checksum: this.data.otpChecksum,
      type: 'email',
      value: this.data.Email,
      otpAction: 'mobileOrEmailValidation',
      channel: 'email',
      companyId: 'SAA',
      eventName: this.data.actionType,
      b2BId: null,
      b2BUserId: null,
    };
    const localSessionId = localStorage.getItem('session_id')
    this._CamService
      .VerifyOTP(payload)
      .then((res: any) => {
        if (res.data.otpVerified) {
          const resSessionId: any = jwtDecode(res.data?.secureSessionId);
          if (localSessionId != resSessionId?.['sessionId']) {
            return;
          }
          this.isVerifying = false;
          if (this.authType !== 'Onboard') {
            if (this.actionDocType == 'DocumentAdd') {
              this.travelerManagement.authentication_success('Verify', 'Success');
            }

            if (this.method == 'dependentMatch') {
              this._DependentDatalayer.linkAccountAuthenticationCTA('Verify', this.verifyMode, this.attemptsLeft);
            }

          }

          this.dialogRef.close('verified');
        } else {
          this.isVerifying = false;
          if (this.authType !== 'Onboard') {
            if (this.actionDocType == 'DocumentAdd') {
              this.travelerManagement.authentication_error_popup('Verify', 'Invalid OTP! .Please try again!', this.verifyMode);
            }

          }

          this.handleInvalidOtp(); // 👈 call on error
          if (this.authType == 'Onboard') {
            this._DataLayerService.otpVerificationErrorOnboarding(
              payload?.type,
              res?.message,
              this.data?.data?.userType == '0' ? 'Admin' : 'Employee'
            );
          }


        }
      })
      .catch((error: any) => {
        this.isVerifying = false;
        this.handleInvalidOtp();
        if (this.authType == 'Onboard') {
          this._DataLayerService.otpVerificationErrorOnboarding(
            payload?.type,
            error?.message,
            this.data?.data?.userType == '0' ? 'Admin' : 'Employee'
          );
        }

      });
  }

  verifyOTP() {
    const payload = {
      otp: Object.values(this.otpForm.value).join(''),
      checksum: this.data.otpChecksum,
      type: 'mobile',
      value: (this.data.countryCode || this.data.isdCode) + this.data.PhoneNumber,
      otpAction: 'mobileOrEmailValidation',
      channel: 'mobile',
      companyId: 'SAA',
      eventName: this.data.actionType,
      b2BId: null,
      b2BUserId: null,
    };
    const localSessionId = localStorage.getItem('session_id')
    this._CamService
      .VerifyOTP(payload)
      .then((res: any) => {
        if (res.data.otpVerified) {
          const resSessionId: any = jwtDecode(res.data?.secureSessionId);
          if (localSessionId != resSessionId?.['sessionId']) {
            return;
          }
          this.isVerifying = false;
          if (this.authType !== 'Onboard') {
            if (this.actionDocType == 'DocumentAdd') {
              this.travelerManagement.authentication_success('Verify', 'Success');
            }

            if (this.method == 'dependentMatch') {
              this._DependentDatalayer.linkAccountAuthenticationCTA('Verify', this.verifyMode, this.attemptsLeft);
            }

          }

          this.dialogRef.close('verified');
        } else {
          this.isVerifying = false;
          if (this.authType !== 'Onboard') {
            if (this.actionDocType == 'DocumentAdd') {
              this.travelerManagement.authentication_error_popup('Verify', 'Invalid OTP! .Please try again!', this.verifyMode);
            }

          }

          this.handleInvalidOtp(); // 👈 call on error
          if (this.authType == 'Onboard') {
            this._DataLayerService.otpVerificationErrorOnboarding(
              payload?.type,
              res?.message,
              this.data?.data?.userType == '0' ? 'Admin' : 'Employee'
            );
          }


        }
      })
      .catch((error: any) => {
        this.isVerifying = false;
        this.handleInvalidOtp();
        if (this.authType == 'Onboard') {
          this._DataLayerService.otpVerificationErrorOnboarding(
            payload?.type,
            error?.message,
            this.data?.data?.userType == '0' ? 'Admin' : 'Employee'
          );
        }


      });
  }

  notMecreateContact() {
    // this._DataLayerService.otpVerificationOnboarding('email', this.attemptsLeft, 'Verify',);
    // this._DataLayerService.onboarding_authentication_click(this.data.verifyMode === 'email' ? 'email' : 'mobile', 'Verify', this.attemptsLeft
    // );

    const d = this.data.data;
    const token = localStorage.getItem('access_token');
    const seesionID = localStorage.getItem('session_id');

    const payload = {
      firstName: d.firstname,
      lastName: d.lastname,
      dateOfBirth: this._CommonService.formatDateToYMD(d.dateOfBirth),
      title: d.title,
      gender: d.gender,
      placeOfResidence: d.residence,
      nationality: d.Nationality,
      email: d.email,
      mobile: d.mobileNumber,
      phoneExtension: d.countryCode,
      employeeCode: d.empCode,
      employeeType: d.userType,
      idNumber: d.identityNumber,
      // idType: this.data.idType,
      idType: this.data.idType === 'iqama' ? 'Iqama' : this.data.idType === 'nationalID' ? 'National ID' : this.data.idType === 'passport' ? 'Passport' : this.data.idType,
      passportNationality: d.Nationality,
      designationId: d.designation,
      departmentId: d.department ?? null,
      branchId: d.branch,
      AlFursanId: d.alfursanID,
      expiryDate: this._CommonService.formatDateToYMD(d.docExpiary),
      password: d.password,
      elmVerified: this.data?.isELMVerified || this.data?.elmStatus || d?.isELMVerified || d?.elmStatus || false,
      isELMVerified: this.data?.isELMVerified || this.data?.elmStatus || d?.isELMVerified || d?.elmStatus || false,
      elmVerificationDate: (this.data?.isELMVerified || this.data?.elmStatus || d?.isELMVerified || d?.elmStatus) ? (this.data?.elmVerificationDate || d?.elmVerificationDate || new Date().toISOString()) : null,
      consentTCPP: this.data.consentTCPP,
      consentMarketingOffers: this.data.consentMarketingOffers,
      consentLinkAccount: false,
      contactId: '',
      // accountId: '4349855f-8ad6-f011-8544-7ced8d4254b4',
      accountId: d.accountID,
      vUserDataKey: this.data?.vUserDataKey,
      flag: 'CREATE',
      companyId: 'SAA',
      otp: Object.values(this.otpForm.value).join(''),
      checksum: this.otpChecksum || this.data.otpChecksum,
      type: 'mobile',
      value: this.data.countryCode + this.data.PhoneNumber,
      otpAction: 'mobileOrEmailValidation',
      Channel: 'mobile',
      B2BId: null,
      B2BUserId: null,
      eventName: this.data.actionType,
      subagentId: d.subagentId,
      saUserId: d.saUserId,
      userGuid: d.userGuid,
    };

    this.service.createNewContact(token, seesionID, null, payload).subscribe({
      next: (res) => {
        console.log(res);
        this.isVerifying = false;
        this.dialogRef.close();
        this._DataLayerService.otpVerificationSuccessOnboarding(
          payload?.type,
          'Thank you for joining Saudia Business',
          'Success',
          payload?.employeeType == '0' ? 'Admin' : payload?.employeeType == '1' ? 'Travel Arranger' : 'Employee'
        );
        this.dialogRef.afterClosed().subscribe(() => {
          this.ThankyouService.show({
            heading: 'Profile successfully created!',
            // description: 'We will verify your company details within 2 business days. Once approved, you will receive a confirmation email.',
            buttonText: 'Go To Login',
            isShowButton: true,
            redirectUrl: '/login-landing',
          });
        });
      },

      error: (err) => {
        console.error('API error:', err);
        this.isVerifying = false;
        const apiErrorMessage = err?.error?.message;

        if (apiErrorMessage === 'Incorrect OTP') {
          let showErrorMsg = this.invalidPassAttemptsLeft > 0 ? `Invalid OTP! You have ${this.invalidPassAttemptsLeft} attempts left.` : 'Verification attempts maxed out. Please try again in some time.';
          if (this.authType == 'Onboard') {
            this._DataLayerService.errors_occured(showErrorMsg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
          }
          if (this.authType == 'Onboard') {
            this._DataLayerService.otpVerificationErrorOnboarding(
              payload?.type,
              showErrorMsg,
              this.data?.data?.userType == '0' ? 'Admin' : 'Employee'
            );
          }
          this.handleInvalidOtp();
        } else {
          let msg = apiErrorMessage || 'Something went wrong';
          try {
            const parsedMsg = JSON.parse(apiErrorMessage);
            msg = parsedMsg?.details?.[0]?.message?.message || parsedMsg?.details?.[0]?.message?.Message || msg;
            if (parsedMsg?.target) {
              msg = `${parsedMsg?.message} - Target: ${parsedMsg?.target}`;
            }
          } catch (e) { }

          this._ToastrApiService.show('error', msg);
          if (this.authType == 'Onboard') {
            this._DataLayerService.onboarding_error('Account already exists', msg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
            this._DataLayerService.errors_occured(msg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
            this._DataLayerService.otpVerificationErrorOnboarding(payload?.type, msg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
          }
        }
      },
    });
  }

  verifyOTPUserDeactivate() {

    const payload = {
      otp: Object.values(this.otpForm.value).join(''),
      checksum: this.data.otpChecksum,
      type: 'email',
      value: this.data.Email,
      otpAction: 'mobileOrEmailValidation',
      channel: 'email',
      companyId: 'SAA',
      eventName: 'UserDeactivate', // 🔥 important
      b2BId: null,
      b2BUserId: null,
    };
    const localSessionId = localStorage.getItem('session_id');
    this._CamService
      .VerifyOTP(payload)
      .then((res: any) => {

        if (res.data.otpVerified) {
          const resSessionId: any = jwtDecode(res.data?.secureSessionId);
          if (localSessionId != resSessionId?.['sessionId']) {
            return;
          }
          this.isVerifying = false;
          if (this.authType !== 'Onboard') {
            this.travelerManagement.authentication_popup('Success', this.verifyMode);
          }

          // ✅ THIS is key — triggers parent flow
          this.dialogRef.close('verified');

        } else {

          this.isVerifying = false;
          if (this.authType !== 'Onboard') {
            this.travelerManagement.authentication_popup(
              'Invalid Otp!',
              this.verifyMode
            );
          }


          this.handleInvalidOtp();
        }
      })
      .catch((error: any) => {

        this.isVerifying = false;
        this.handleInvalidOtp();

      });
  }

  
  savePhoneEnrollment() {
    const payload = {
      auth_session: this.data.authSession,
      otpCode: Object.values(this.otpForm.value).join('')
    };

    const authenticationID = this.data.phoneId;
    this.isVerifying = true;
    this._CommonService.loaderSubject.next(true);

    this._CamService.confirmPhoneEnrollment(payload, authenticationID)
      .subscribe({
        next: (res: any) => {
          console.log('confirmPhoneEnrollment response:', res);
          this.callSecondApi();
        },
        error: (err: any) => {
          this.isVerifying = false;
          this._CommonService.loaderSubject.next(false);
          console.error('Error confirming phone enrollment', err);
          this._ToastrApiService.show('error', "Error occured during confirmPhoneEnrollment.");
        }
      });
  }

  callSecondApi() {
    this.isVerifying = true;
    this._CommonService.loaderSubject.next(true);
    const phoneNumber = `${this.data.isdCode}${this.data.PhoneNumber}`;
    const crmId = localStorage.getItem('CRMID') || '';
    const pload = {
      phonenumber: phoneNumber,
      CRMID: crmId
    };
    const userId = localStorage.getItem('CIAMID') || '';

    this._CamService.phoneVerifiedCiam(pload, userId).subscribe({
      next: (response: any) => {
        console.log('phoneVerifiedCiam response', response);
        this.updateProfile();

      },
      error: (err: any) => {
        this.isVerifying = false;
        this._CommonService.loaderSubject.next(false);
        console.error('Error creating phoneVerifiedCiam', err);
        this._ToastrApiService.show('error', "Error occured during phoneVerifiedCiam.");
        this.dialogRef.close(true);
      }
    });
  }

  updateProfile() {
    this.isVerifying = true;
    this._CommonService.loaderSubject.next(true);
    const ciamID = localStorage.getItem('CIAMID') || '';
    const crmid = localStorage.getItem('CRMID') || '';
    const flag = this.data.flag;
    const mobileNumber = this.data.PhoneNumber;
    const payload = {
      CRMID: crmid,
      CIAMID: ciamID,
      flag: flag,
      mobileNumber: mobileNumber,
      vUserDataKey: this.data?.vUserDataKey,
      primaryContactId: this.data?.primaryContactID,
      countryCode: this.data.isdCode,
    };

    this._CamService.updateProfileMerge(payload).subscribe({
      next: (response: any) => {
        console.log('updateProfileMerge response', response);

        localStorage.setItem('phoneVerified', 'true');
        sessionStorage.setItem('phoneVerified', 'true');

        // Clear Auth0 cached SPA tokens to force fresh claims upon next login
        for (let i = localStorage.length - 1; i >= 0; i--) {
          const key = localStorage.key(i);
          if (key && key.startsWith('@@auth0spajs@@::')) {
            localStorage.removeItem(key);
          }
        }

        this.ThankyouService.show({
          heading: 'Your mobile successfully updated',
          description: 'You can now login',
          buttonText: 'Login',
          isShowButton: true,
          redirectUrl: '/login-landing',
          ciamToken: null as any
        });

        this.isVerifying = false;
        this._CommonService.loaderSubject.next(false);

        setTimeout(() => {
          this.dialogRef.close(true);
        }, 300);
      },
      error: (err: any) => {
        this.isVerifying = false;
        this._CommonService.loaderSubject.next(false);
        console.error('Error creating updateProfileMerge', err);
        this._ToastrApiService.show('error', 'Error occurred during update profile.');
      }
    });
  }

  // otpEmailVerification(formData: any) {
  //   const formValue = formData;
  //   const admiName = `${formValue.FirstName} ${formValue.LastName}`;
  //   const companyName = formValue.CompanyName;

  //   const payload: any = {
  //     employeeName: admiName,
  //     otp: Object.values(this.otpForm.value).join(''),
  //     companyName: companyName,
  //     supportUrl: this.suportUrl || ''
  //   };

  //   const finalPayload = {
  //     lang: 'en-SA',
  //     notificationEvent: 'b2bRegistrationEmailOtp',
  //     notificationParameters: payload,
  //     recipients: {
  //       to: [
  //         {
  //           address: formValue.Email
  //         }
  //       ]
  //     },
  //     attachments: []
  //   };
  //   console.log('final payload otp mail verification ', finalPayload)
  //   this._CamService.sendEmailNotification('email', finalPayload).subscribe({
  //     next: (res: any) => {
  //       console.log('OtpEmailVerification response', res);
  //     },
  //     error: (err): any => {
  //       console.log('OtpEmailVerification response', err);
  //       if (this.authType == 'Onboard') {
  //         this._DataLayerService.errors_occured(err, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
  //       }

  //     }
  //   })

  // }

  // async corporateRegistrationWelcome(formData: any) {
  //   const formValue = formData;
  //   const admiName = `${formValue.FirstName} ${formValue.LastName}`;
  //   const companyName = formValue.CompanyName;
  //   const payload: any = {
  //     adminName: admiName,
  //     companyName: companyName,
  //     supportUrl: this.suportUrl || ''
  //   };

  //   const finalPayload = {
  //     lang: 'en-SA',
  //     notificationEvent: 'b2bRegistrationSuccessful',
  //     notificationParameters: payload,
  //     recipients: {
  //       to: [
  //         {
  //           address: formValue.Email
  //         }
  //       ]
  //     },
  //     attachments: []
  //   };

  //   console.log('final payload corporate registration welcome mail', finalPayload);
  //   const ctaUrl = await this.generateTravelerCTAUrl(formValue.Email);
  //   this._CamService.sendEmailNotification('email', finalPayload).subscribe({
  //     next: (res: any) => {
  //       console.log('Corporate registration  welcome', res);
  //       //First Admin Registered Sucessfully Email
  //       // const payloads: any = {
  //       //   employeeName: admiName,
  //       //   ctaUrl: ctaUrl || '',
  //       //   companyName: companyName,
  //       //   supportUrl: this.suportUrl || ''
  //       // };

  //       // const finalPayloads = {
  //       //   lang: 'en-SA',
  //       //   notificationEvent: 'b2bSuccessfulFirstAdminProfileSetup',
  //       //   notificationParameters: payloads,
  //       //   recipients: {
  //       //     to: [
  //       //       {
  //       //         address: formValue.Email
  //       //       }
  //       //     ]
  //       //   },
  //       //   attachments: []
  //       // };
  //       // console.log('final payloads corporate registration welcome mail', finalPayloads);
  //       // this._CamService.sendEmailNotification('email', finalPayloads).subscribe({
  //       //   next: (res: any) => {
  //       //     console.log('First admin registerd response', res)
  //       //   },
  //       //   error: (err: any) => {
  //       //     console.log('First admin registered error', err)
  //       //   }
  //       // })
  //     },
  //     error: (err: any) => {
  //       console.log('coroprate regitration welcome error', err);
  //     }
  //   })
  // }

  async generateTravelerCTAUrl(email: string): Promise<string | null> {
    try {
      const response = await this._CamService.createTravelerToken(email);

      if (response?.status === 'Created' || response?.status === 'Success') {
        const token = response?.data;

        if (token) {
          const baseUrl = window.location.origin;
          const targetUrl = `${baseUrl}/traveler-signup?token=${encodeURIComponent(token)}`;

          return targetUrl;
        }
      }
    } catch (error: any) {
      console.error("token generate error", error);
    }

    return null;
  }

  personalInfoMobNotMe() {
    const accountID = localStorage.getItem('additionalRefNo')
    console.log(this.data)
    const formData = this.data?.data

    const isPhoneDetailsChanged = !!formData?.phoneNumber || !!formData?.countryCode;
    const isEmailFieldChanged = !!formData?.emailAddress;
    const isAlfursanChanged = !!formData?.alfursanID;

    let isEmailChanged: boolean | null = null;
    let isMobileChanged: boolean | null = null;

    if (isEmailFieldChanged || isPhoneDetailsChanged) {
      isEmailChanged = true;
    }

    if (isPhoneDetailsChanged) {
      isMobileChanged = true;
    }

    const payload = {
      saUserid: formData?.saUserid,
      Title: formData?.title,
      UserFirstName: formData?.userFirstName,
      UserLastName: formData?.userLastName,
      UserDOB: formData?.userDOB,
      Gender: formData?.gender,
      EmployeeCode: formData?.employeeCode,
      EmailAddress: formData?.emailAddress,
      countryCode: (isAlfursanChanged && !isPhoneDetailsChanged) ? null : formData?.countryCode,
      PhoneNumber: (isAlfursanChanged && !isPhoneDetailsChanged) ? null : formData?.phoneNumber,
      IsCorpTravelArranger:
        formData?.IsCorpTravelArranger,
      IsProceedToCheckout:
        formData?.isEmpRightsForTrip,
      BlockUserLiveAccess:
        formData?.allowUserLiveAccess,
      ConsentTC: formData?.cocnsentTC,
      ConsentTCPP: formData?.consentTCPP,
      ConsentMarketing: formData?.ConsentMarketing,
      Flag: formData?.flag,
      Guid: formData?.GUID,
      accountID: accountID,
      vUserDataKey: this.data?.vUserDataKey,
      AlFursanId: formData?.alfursanID,

      data: {
        isEmailVerified: isEmailChanged,
        isPhoneVerified: isMobileChanged,
        // ciamId: this.data?.ciamId,
        ciamId: (isEmailChanged === true || isMobileChanged === true) ? this.data?.ciamId : null,

      },
      primaryContactId: null,
      secondaryContactId: this.data?.secondaryContactId,
      consentMerge: false,
      otp: Object.values(this.otpForm.value).join(''),
      checksum: this.data?.otpChecksum,
      type: 'mobile',
      value: formData?.phoneNumber,
      otpAction: 'mobileOrEmailValidation'
    };

    this._CamService
      .UpdatePersonalInformationDetails(payload)
      .then(($res) => {
        this.travelerManagement.traveler_detail_click('Save');
        if ($res.status == 'Failure') {
          this.dialogRef.close();
          this._ToastrApiService.show('error', $res.message);
          this.isVerifying = false
          return;
        }
        if ($res.status == 'Success') {
          this.dialogRef.close();
          this._ToastrApiService.show(
            'success', 'Personal Information updated successfully.'
          );

        }

      })
      .catch((error) => {
        console.error('Error saving data', error);
        this.isVerifying = false;
        const apiErrorMessage = error?.error?.message || error?.message;

        if (apiErrorMessage === 'Incorrect OTP') {
          this.handleInvalidOtp();
          let showErrorMsg = this.invalidPassAttemptsLeft > 0 ? `Invalid OTP! You have ${this.invalidPassAttemptsLeft} attempts left.` : 'Verification attempts maxed out. Please try again in some time.';
          this._ToastrApiService.show('error', showErrorMsg);
        } else {
          let msg = apiErrorMessage || 'Something went wrong';
          try {
            const parsedMsg = JSON.parse(apiErrorMessage);
            msg = parsedMsg?.details?.[0]?.message?.message || parsedMsg?.details?.[0]?.message?.Message || msg;
            if (parsedMsg?.target) {
              msg = `${parsedMsg?.message || msg} - Target: ${parsedMsg?.target}`;
            }
          } catch (e) { }

          this._ToastrApiService.show('error', msg);
        }
      });
  }

  personalInfoAlfursanMatch() {
    const accountID = localStorage.getItem('additionalRefNo')
    console.log(this.data)
    const formData = this.data?.data?.data

    const isPhoneDetailsChanged = !!formData?.phoneNumber || !!formData?.countryCode;
    const isEmailFieldChanged = !!formData?.emailAddress;
    const isAlfursanChanged = !!formData?.alfursanID;

    let isEmailChanged: boolean | null = null;
    let isMobileChanged: boolean | null = null;

    if (isEmailFieldChanged || isPhoneDetailsChanged) {
      isEmailChanged = true;
    }

    if (isPhoneDetailsChanged) {
      isMobileChanged = true;
    }

    const payload = {
      saUserid: formData?.saUserid,
      Title: formData?.title,
      UserFirstName: formData?.userFirstName,
      UserLastName: formData?.userLastName,
      UserDOB: formData?.userDOB,
      Gender: formData?.gender,
      EmployeeCode: formData?.employeeCode,
      EmailAddress: formData?.emailAddress,
      countryCode: (isAlfursanChanged && !isPhoneDetailsChanged) ? null : formData?.countryCode,
      PhoneNumber: (isAlfursanChanged && !isPhoneDetailsChanged) ? null : formData?.phoneNumber,
      IsCorpTravelArranger:
        formData?.IsCorpTravelArranger,
      IsProceedToCheckout:
        formData?.isEmpRightsForTrip,
      BlockUserLiveAccess:
        formData?.allowUserLiveAccess,
      ConsentTC: formData?.cocnsentTC,
      ConsentTCPP: formData?.consentTCPP,
      ConsentMarketing: formData?.ConsentMarketing,
      Flag: formData?.flag,
      Guid: formData?.GUID,
      accountID: accountID,
      vUserDataKey: this.data?.vUserDataKey,
      AlFursanId: formData?.alfursanID,

      data: {
        isEmailVerified: isEmailChanged,
        isPhoneVerified: isMobileChanged,
        // ciamId: this.data?.data?.ciamID,
        ciamId: (isEmailChanged === true || isMobileChanged === true) ? this.data?.data?.ciamID : null,

        
        
      },
      primaryContactId: this.data?.primaryContactID,
      secondaryContactId: this.data?.data?.secondaryContactID,
      consentMerge: true,
      otp: Object.values(this.otpForm.value).join(''),
      checksum: this.data?.otpChecksum,
      type: 'email',
      value: this.data?.Email,
      otpAction: 'mobileOrEmailValidation'
    };

    this._CamService
      .UpdatePersonalInformationDetails(payload)
      .then(($res) => {
        this.travelerManagement.traveler_detail_click('Save');
        if ($res.status == 'Failure') {
          this.dialogRef.close();
          this._ToastrApiService.show('error', $res.message);
          this.travelerManagement.loyalty_update_status('Failure', $res?.error?.message || $res?.message);
          this.isVerifying = false
          return;
        }
        if ($res.status == 'Success') {
          this.dialogRef.close();
          this._ToastrApiService.show(
            'success', 'Personal Information updated successfully.'
          );
          this.travelerManagement.loyalty_update_status('Success', 'NA');
          this._CamService.personalInfoUpdateSuccess$.next($res);
        }

      })
      .catch((error) => {
        console.error('Error saving data', error);
        this.isVerifying = false;
        const apiErrorMessage = error?.error?.message || error?.message;

        if (apiErrorMessage === 'Incorrect OTP') {
          this.handleInvalidOtp();
          let showErrorMsg = this.invalidPassAttemptsLeft > 0 ? `Invalid OTP! You have ${this.invalidPassAttemptsLeft} attempts left.` : 'Verification attempts maxed out. Please try again in some time.';
          this._ToastrApiService.show('error', showErrorMsg);
        } else {
          let msg = apiErrorMessage || 'Something went wrong';
          try {
            const parsedMsg = JSON.parse(apiErrorMessage);
            msg = parsedMsg?.details?.[0]?.message?.message || parsedMsg?.details?.[0]?.message?.Message || msg;
            if (parsedMsg?.target) {
              msg = `${parsedMsg?.message || msg} - Target: ${parsedMsg?.target}`;
              this.travelerManagement.loyalty_update_status('Failure', msg);
            }
          } catch (e) { }

          this._ToastrApiService.show('error', msg);
          
        }
      });
  }

  thisIsMeDocumentInfoChange() {

    console.log(this.data)
    const accountID = localStorage.getItem('additionalRefNo');
    const formData = this.data?.data;
    const ciamID = this.data?.personalDetail?.personalInfo?.ciamId;
    const contactID = this.data?.personalDetail?.personalInfo?.contactId;
    const id = this.data?.personalDetail?.element?.id;
    const userId = sessionStorage.getItem("userId") || "";

    const payload = {
      QueryNo: 3,
      passportID: id,
      passportNationality: formData?.countryControl0,
      countryOfResidence: formData?.placeOfResidence,
      DocumentType: formData?.DocType,
      passportDOB: this._CommonService.formatDateToISOString(formData?.DOB) || null,
      passportCountryCode: formData?.issueCountry || null,
      passportPOI: formData?.passportPOI || null,
      passportValidityStartDate: this._CommonService.formatDateToISOString(formData?.Validfromdate) || null,
      PassportExpiryDate: this._CommonService.formatDateToISOString(formData?.ExpiryDate) || null,
      isPrimary: true,
      passportNumber: formData?.Passportno,
      primaryContactId: this.data?.secondaryContactId || null,
      secondaryContactId: contactID || null,
      consentMerge: true,
      accountID: accountID,
      ciamId: ciamID || null,
      elmVerified: false,
      isELMVerified: false,
      elmVerificationDate: null,
      vUserDataKey: this.data?.vUserDataKey,
      firstName: this.data?.targetFirstName !== undefined ? this.data?.targetFirstName : null,
      lastName: this.data?.targetLastName !== undefined ? this.data?.targetLastName : null,

      otp: Object.values(this.otpForm.value).join(''),
      checksum: this.data?.otpChecksum,
      type: 'email',
      value: this.data?.Email,
      otpAction: 'mobileOrEmailValidation'

    }

    this._CamService.UpdateDocumentDetails(userId, payload).then(response => {

      this._ToastrApiService.show('success', "Document information updated successfully.");
      // this.travelerMangement.document_edit_save('Save');
      // this.travelerMangement.document_save_success('Success');
      setTimeout(() => {
        // this.Loader.isSpinner = false;
        this.dialogRef.close();
        window.location.reload();
      }, 1000);
    })
      .catch((error) => {
        console.error('Error saving data', error);
        this.isVerifying = false;
        const apiErrorMessage = error?.error?.message || error?.message;

        if (apiErrorMessage === 'Incorrect OTP') {
          this.handleInvalidOtp();
          let showErrorMsg = this.invalidPassAttemptsLeft > 0 ? `Invalid OTP! You have ${this.invalidPassAttemptsLeft} attempts left.` : 'Verification attempts maxed out. Please try again in some time.';
          this._ToastrApiService.show('error', showErrorMsg);
        } else {
          let msg = apiErrorMessage || 'Something went wrong';
          try {
            const parsedMsg = JSON.parse(apiErrorMessage);
            msg = parsedMsg?.details?.[0]?.message?.message || parsedMsg?.details?.[0]?.message?.Message || msg;
            if (parsedMsg?.target) {
              msg = `${parsedMsg?.message || msg} - Target: ${parsedMsg?.target}`;
            }
          } catch (e) { }

          this._ToastrApiService.show('error', msg);
        }
      });

  }


  thisIsMeDocumentInfoADD() {
    console.log(this.data)
    const formData = this.data?.data
    const personalInfo = this.data?.personalDetail
    const userId = sessionStorage.getItem("userId") || "";
    const accountID = localStorage.getItem('additionalRefNo');
    let firstname = null;
    let lastname = null;
    if (this.data?.targetFirstName !== undefined) {
      firstname = this.data.targetFirstName;
      lastname = this.data.targetLastName;
    } else if (this.data?.docname) {
      const parts = this.data.docname.split(' ');
      firstname = parts[0] || null;
      lastname = parts[1] || null;
    }

    const payload = {
      queryNo: 2,
      passportID: 0,
      passportNationality: formData.countryControl0,
      countryOfResidence: formData.placeOfResidence,
      DocumentType: formData.DocType,
      passportNumber: formData.Passportno,
      passportDOB: this.formatDateToISOString(formData.DOB) || null,
      passportCountryCode: formData.issueCountry || null,
      passportPOI: formData.passportPOI || null,
      passportValidityStartDate: formData.Validfromdate ? this.formatDateToISOString(formData.Validfromdate) : null,
      PassportExpiryDate: this.formatDateToISOString(formData.ExpiryDate) || null,
      isPrimary: true,
      // email: personalInfo?.email || null,
      ciamId: personalInfo?.ciamId || null,
      firstName: firstname,
      lastName: lastname,
      accountID: accountID,
      vUserDataKey: this.data?.vUserDataKey,
      primaryContactId: this.data?.primaryContactID,
      secondaryContactId: personalInfo?.contactId || null,
      consentMerge: true,
      elmVerified: this.data?.isELMVerified,
      isELMVerified: this.data?.isELMVerified,
      elmVerificationDate: this.data?.elmVerificationDate,

      otp: Object.values(this.otpForm.value).join(''),
      checksum: this.data?.otpChecksum,
      type: 'email',
      value: this.data?.Email,
      otpAction: 'mobileOrEmailValidation'
    };
    console.log("Payload",)

    this._CamApiService.UpdateDocumentDetails(userId, payload).then(response => {
      this._ToastrApiService.show('success', "Document information Insert successfully.")
      this._CommonService.formResetTrigger(); //to reset the form
      this.dialogRef.close();
      this.isVerifying = false


    })
      .catch((error) => {
        console.error('Error saving data', error);
        this.isVerifying = false;
        const apiErrorMessage = error?.error?.message || error?.message;

        if (apiErrorMessage === 'Incorrect OTP') {
          this.handleInvalidOtp();
          let showErrorMsg = this.invalidPassAttemptsLeft > 0 ? `Invalid OTP! You have ${this.invalidPassAttemptsLeft} attempts left.` : 'Verification attempts maxed out. Please try again in some time.';
          this._ToastrApiService.show('error', showErrorMsg);
        } else {
          let msg = apiErrorMessage || 'Something went wrong';
          try {
            const parsedMsg = JSON.parse(apiErrorMessage);
            msg = parsedMsg?.details?.[0]?.message?.message || parsedMsg?.details?.[0]?.message?.Message || msg;
            if (parsedMsg?.target) {
              msg = `${parsedMsg?.message || msg} - Target: ${parsedMsg?.target}`;
            }
          } catch (e) { }

          this._ToastrApiService.show('error', msg);
          this._CommonService.formResetTrigger(); //to reset the form
        }
      });
  }

  formatDateToISOString(dateStr: string): string {
    const parts = dateStr.split('/').map(Number);
    if (parts.length !== 3 || parts.some(isNaN)) {
      throw new Error(`Invalid date format: ${dateStr}`);
    }
    let [day, month, year] = parts;
    month = month - 1;
    const date = new Date(year, month, day);
    if (isNaN(date.getTime())) {
      throw new Error(`Invalid date object created from: ${dateStr}`);
    }
    const pad = (num: number) => num.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate(),
    )}T00:00:00`;
  }

  ngOnDestroy(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval); // Cleanup when the component is destroyed
    }
  }
}
